import { createApi } from "@reduxjs/toolkit/query/react";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { customFetchBase } from "../../utils/API/fetchBaseQuery";

const taskattachmentAPI = createApi({
    reducerPath: "taskattachmentAPI",
    baseQuery: customFetchBase,
    endpoints: (builder) =>({
        getalltaskattachment: builder.query({
            query: ({taskId,projectId}) => ({
                url: `TaskAttachment/GetTaskAttachmentListByTaskIdAndProjectId?TaskId=${taskId}&ProjectId=${projectId}`,
                method: 'GET',
            }),

            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addTaskAttachment:builder.mutation({
            query:(data)=>({
                url:`TaskAttachment/AddTaskAttachment`,
                method:'POST',
                body:transformRequest(data)
            }),
            transformResponse:transformSuccessResponse,
            transformErrorResponse:transformErrorResponse,
        }),
        deleteTaskAttachment:builder.mutation({
            query: (data) => ({
                url: `/TaskAttachment/DeleteTaskAttachment?TaskAttachmentId=${data}`,
                method: 'DELETE',
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getDownloadFile: builder.query({
            query: (fileName) => ({
                url: `/TaskAttachment/DownloadDocument?fileName=${fileName}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),

            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })

})

export const {
    useLazyGetalltaskattachmentQuery,
    useAddTaskAttachmentMutation,
    useDeleteTaskAttachmentMutation,
    useLazyGetDownloadFileQuery
} = taskattachmentAPI;

export default taskattachmentAPI;

